/* istanbul ignore file */
export * from './CategoryPageBrandOverview';
